// Polyfill from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md.
((arr) => {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

(($, Drupal, drupalSettings) => {
  'use strict';

  const spa_lite_dialog_type = 'drupal_spa_lite_ajax';
  // ToDo: Html classes preserved while body classes ARE NOT, fix them!
  const body_classes_preserved = [];
  const html_classes_preserved = ['facets-revealed', 'socials-revealed', 'search-revealed', 'menu-revealed'];

  const link_validation_rules = {
    classes: [
      'use-ajax',
      'spa-lite-ignore',
      'wr-infinite-pager',
    ],
    regs: [
      /^\/user/,
      /^\/admin$/,
      /\/admin\/.*/
    ]
  };

  const query_validation_rules = [
    /_wrapper_format=[a-zA-Z_\-]+/m
  ];

  /**
   * Handle history shifts.
   *
   * @param e
   *   Popstate event.
   */
  window.onpopstate = (e) => {
    if (e.state !== null) {
      updateDocumentProps(e.state);
      dispatchSpaEvent();
    }
  };

  /**
   * Verify that link needs to be processed.
   *
   * @param link
   *   DOM element
   *
   * @returns {boolean}
   *   Assertion.
   */
  let validateLink = (link) => {
    // Empty or external.
    if (link.hostname === '' || link.hostname !== window.location.hostname) {
      return false;
    }

    // One of player buttons.
    if (link.hasAttribute('data-warner-player-listen')) {
      return false;
    }

    // Should be opened in a new tab.
    if (link.getAttribute('target') === '_blank') {
      return false;
    }

    // Ignore media requests.
    if (link.pathname.indexOf('/sites/default/files') !== -1) {
      return false;
    }

    // Oddly constructed link, most likely for JS purposes.
    if (link.href === null || link.href === '' || link.href === '#' || link.pathname === '#') {
      return false;
    }

    // Same case as previous assertion.
    if (link.href === window.location.href + '#') {
      return false;
    }

    if (link.pathname === window.location.pathname && link.href.split('#').length > 1) {
      return false;
    }

    // Match by class to avoid interference with alternative AJAX handlers or on purpose excludes.
    for (let i in link_validation_rules.classes) {
      if (link_validation_rules.classes.hasOwnProperty(i)) {
        if (link.classList.contains(link_validation_rules.classes[i])) {
          return false;
        }
      }
    }

    // Match by regexp, e.g. to filter out system paths.
    for (let i in link_validation_rules.regs) {
      if (link_validation_rules.regs.hasOwnProperty(i)) {
        if (link_validation_rules.regs[i].test(link.pathname)) {
          return false;
        }
      }
    }

    return true;
  };

  let cleanupUlr = (url_orig) => {
    let url_components = url_orig.split('?');

    // Deconstruct URL into components, filter out query parameters.
    if (url_components.length === 2) {
      let url_body = url_components[0],
        leftover = url_components[1].split('#'),
        query_params = leftover[0].split('&'),
        query_hash = leftover.length === 2 ? leftover[1] : '';

      for (let i = query_params.length - 1; i >= 0; i--) {
        if (query_params.hasOwnProperty(i)) {
          for (let j = 0; j < query_validation_rules.length; j++) {
            if (query_validation_rules.hasOwnProperty(j) && query_validation_rules[j].test(query_params[i])) {
              query_params.splice(i, 1);
            }
          }
        }
      }

      url_orig = url_body;

      if (query_params.length > 0) {
        url_orig += '?' + query_params.join('&');
      }

      if (query_hash !== '') {
        url_orig += '#' + query_hash;
      }
    }

    return url_orig;
  };

  /**
   * Event callback for click on a link.
   *
   * @param link
   *   DOM element.
   * @param event
   *   Optional click event.
   */
  let handleLinkInteraction = (event, link) => {
    // In case if it's an internal link and protocol tries to switch from https to http, prevent it.
    if (link.protocol === 'http:' && window.location.hostname === link.hostname && window.location.protocol !== link.protocol) {
      link.protocol = window.location.protocol;
    }

    if (!validateLink(link)) {
      return;
    }

    let dynamic_wrapper = document.getElementById('page-dynamic-content');

    if (typeof(dynamic_wrapper) === 'object') {
      if (event) {
        event.preventDefault();
      }
      let url = link.getAttribute('href');

      Drupal.SpaLite.handleUrl(url, true);
    }
  };

  /**
   * Update attributes of specified element.
   *
   * @param attribute_list
   *   Array of new attributes
   * @param element
   *   DOM element to update.
   * @param preserve_list
   *   Array of attributes that should be preserved.
   */
  let updateAttributes = (attribute_list, element, preserve_list) => {
    let new_classes_exist = typeof(attribute_list.class) !== 'undefined';

    if (new_classes_exist) {
      let classes_new = attribute_list.class;
      delete attribute_list.class;

      for (let class_index = element.classList.length -1; class_index >= 0; class_index--) {
        if (element.classList.hasOwnProperty(class_index)) {
          // Skip if class should be preserved.
          if (preserve_list.indexOf(element.classList[class_index]) !== -1) {
            continue;
          }

          // If class that is going to be added already exists, remove it from the list of additions and skip deletion
          // from active classes.
          if (classes_new.indexOf(element.classList[class_index]) !== -1) {
            delete classes_new[classes_new.indexOf(element.classList[class_index])];
            continue;
          }

          if (element.classList.length && element.classList.contains(element.classList[class_index])) {
            element.classList.remove(element.classList[class_index]);
          }
        }
      }

      // Iterate through new classes and add them to the element if necessary.
      for (let class_index in classes_new) {
        if (classes_new.hasOwnProperty(class_index) && !element.classList.contains(classes_new[class_index])) {
          element.classList.add(classes_new[class_index]);
        }
      }
    }

    for (let attribute_index = element.attributes.length - 1; attribute_index >=0; attribute_index--) {
      if (element.attributes.hasOwnProperty(attribute_index)) {
        let attribute_name = element.attributes[attribute_index].name;

        if (attribute_name !== 'class') {
          if (attribute_list.hasOwnProperty(attribute_name)) {
            element.setAttribute(attribute_name, attributePrepareForEmbed(attribute_list[attribute_name]));
            delete attribute_list[attribute_name];
          }
          else {
            element.removeAttribute(attribute_name);
          }
        }
      }
    }

    for (let attribute_index in attribute_list) {
      if (attribute_list.hasOwnProperty(attribute_index)) {
        element.setAttribute(attribute_index, attributePrepareForEmbed(attribute_list[attribute_index]));
      }
    }
  };

  /**
   * Prepare attributes before settings them into DOM element.
   *
   * @param attribute
   *   Array or string representing attribute value.
   *
   * @returns {*}
   *   Supposedly string.
   */
  let attributePrepareForEmbed = (attribute) => {
    if (Array.isArray(attribute)) {
      return attribute.join(' ');
    }

    return attribute;
  };

  /**
   * Update head elements of the page(metatags, links)
   *
   * @param element_list_new
   *   Array of new metatags and links.
   */
  let updateHeadElements = (element_list_new) => {
    let headElement = document.getElementsByTagName('head').item(0);
    let metaList = headElement.getElementsByTagName('meta');
    let linkList = headElement.getElementsByTagName('link');


    for (let i = linkList.length - 1; i >= 0; i--) {
      if (linkList.item(i).getAttribute('rel') !== 'stylesheet') {
        linkList.item(i).remove();
      }
    }

    for (let i = metaList.length - 1; i >= 0 ; i--) {
      metaList.item(i).remove();
    }

    for (let key in element_list_new) {
      if (element_list_new.hasOwnProperty(key)) {
        let tagNew = document.createElement(element_list_new[key]['#tag']);

        if (element_list_new[key].hasOwnProperty('#attributes')) {
          for (let attrName in element_list_new[key]['#attributes']) {
            if (element_list_new[key]['#attributes'].hasOwnProperty(attrName)) {
              tagNew.setAttribute(attrName, element_list_new[key]['#attributes'][attrName]);
            }
          }
        }

        headElement.appendChild(tagNew);
      }
    }
  };

  /**
   * Update properties of HTML page.
   *
   * @param props
   *   Array of new properties(page title, metatags, links, body tag attributes, html tag attributes).
   */
  let updateDocumentProps = (props) => {
    let dynamic_part = document.getElementById('page-dynamic-content');
    let title = document.getElementsByTagName('title')[0];

    title.innerHTML = props.title;
    dynamic_part.innerHTML = props.string;

    let body = document.getElementsByTagName('body')[0];
    let html = document.getElementsByTagName('html')[0];

    updateAttributes(props.bodyAttributes, body, body_classes_preserved);
    updateAttributes(props.htmlAttributes, html, html_classes_preserved);
    updateHeadElements(props.attachments.head);

    if (typeof(_s) !== 'undefined' && _s.hasOwnProperty('dtm') && _s.dtm.hasOwnProperty('clearVars')) {
      _s.dtm.clearVars();
    }
    window.digitalData = props.trackingData;
    if (typeof(_satellite) !== 'undefined' && _satellite.hasOwnProperty('track')) {
      _satellite.track('page view');
    }

    // Replacing drupalSettings with new one.
    for (let i = 0; i < props.attachments.scripts_bottom.length; i++) {
      if (props.attachments.scripts_bottom[i]['#attributes']['data-drupal-selector'] == "drupal-settings-json") {
        window.drupalSettings = JSON.parse(props.attachments.scripts_bottom[i]['#value']);
        break;
      }
    }

    Drupal.attachBehaviors(document, window.drupalSettings);
  };

  Drupal.behaviors.spa_lite = {
    attach (context, settings) {
      $('a', context).once('handleLinks').bind('click', (e) => {
        handleLinkInteraction(e, e.currentTarget);
      });
    }
  };

  /**
   * Ajax command for cases of Drupal Ajax API usage.
   */
  Drupal.AjaxCommands.prototype.spa_lite = (ajax, response, status) => {
    updateDocumentProps(response);
  };

  /**
   * Override default Drupal Ajax error callback to handle errors explicitly.
   */
  Drupal.Ajax.prototype.error = (xmlhttprequest, uri, customMessage) => {
    if (this.progress.element) {
      $(this.progress.element).remove();
    }
    if (this.progress.object) {
      this.progress.object.stopMonitoring();
    }

    $(this.wrapper).show();

    $(this.element).prop('disabled', false);

    if (this.$form) {
      const settings = this.settings || drupalSettings;
      Drupal.attachBehaviors(this.$form.get(0), settings);
    }

    if (this.dialogType === spa_lite_dialog_type) {
      let response = xmlhttprequest.responseJSON;

      // @see ajax.es6.js:Drupal.Ajax.prototype.success for source of this portion
      const elementParents = $(this.element).parents('[data-drupal-selector]').addBack().toArray();

      let focusChanged = false;
      Object.keys(response || {}).forEach((i) => {
        if (response[i].command && this.commands[response[i].command]) {
          this.commands[response[i].command](this, response[i], status);
          if (response[i].command === 'invoke' && response[i].method === 'focus') {
            focusChanged = true;
          }
        }
      });

      if (!focusChanged && this.element && !$(this.element).data('disable-refocus')) {
        let target = false;

        for (let n = elementParents.length - 1; !target && n > 0; n--) {
          target = document.querySelector(`[data-drupal-selector="${elementParents[n].getAttribute('data-drupal-selector')}"]`);
        }

        if (target) {
          $(target).trigger('focus');
        }
      }

      if (this.$form) {
        const settings = this.settings || drupalSettings;
        Drupal.attachBehaviors(this.$form.get(0), settings);
      }

      this.settings = null;
    }
    else {
      if (this.$form) {
        const settings = this.settings || drupalSettings;
        Drupal.attachBehaviors(this.$form.get(0), settings);
      }

      throw new Drupal.AjaxError(xmlhttprequest, uri, customMessage);
    }

  };

  Drupal.SpaLite = {
    handleUrl(url, scroll) {
      let url_orig = url;
      let url_without_anchor = url.split('#');
      if (url_without_anchor.length == 2) {
        url = url_without_anchor[0]
      }
      if (url.indexOf('?') === -1) {
        url += '?';
      }
      else {
        url += '&';
      }

      url += '_wrapper_format=' + spa_lite_dialog_type;

      $('.page-dynamic-content-overlay').show();

      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function(response) {
        $('.page-dynamic-content-overlay').hide();

        let resp_url_parser = document.createElement('a');
        resp_url_parser.setAttribute('href', response.url);

        let resp_url = cleanupUlr(resp_url_parser.pathname + resp_url_parser.search + resp_url_parser.hash);
        if (url_without_anchor.length == 2) {
          resp_url = cleanupUlr(resp_url_parser.pathname + '#' + url_without_anchor[1]);
        }
        if (url_orig !== resp_url) {
          url_orig = resp_url;
        }

        return response.json();
      }).then(function(json) {
        // Allow form widgets to detach properly.
        Drupal.detachBehaviors(window, null, 'spa_lite_detach');

        if (json[0].newUrl) {
          url_orig = json[0].newUrl;
        }

        history.pushState(json[0], json[0].title, cleanupUlr(url_orig));

        updateDocumentProps(json[0]);

        if (scroll) {
          window.scroll(0, 0);
        }

        dispatchSpaEvent();
      });
    }
  };

  function dispatchSpaEvent() {
    let event = new Event('SpaLiteContentLoaded');
    document.dispatchEvent(event);
  }

})(jQuery, Drupal, drupalSettings);
